/* ==========================================================================
   FOOTBALL-THEME :: Models filter browser
   Brand card -> stacked family sections -> horizontally sliding version
   rows, modelled on the CleatzElite brand page. Applying a version updates
   the existing FacetFiltersForm in place, so the page never navigates and
   the URL stays shareable.
   ========================================================================== */

(function () {
  if (window.__fsModelBrowserBoot) return;
  window.__fsModelBrowserBoot = true;

  var P = {
    brand: 'filter.p.m.custom.brand',
    model: 'filter.p.m.custom.model',
    version: 'filter.p.m.custom.version'
  };

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function find(root, attr, value) {
    var nodes = root.querySelectorAll('[' + attr + ']');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].getAttribute(attr) === value) return nodes[i];
    }
    return null;
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value || '';
  }

  function setScreen(root, screen) {
    root.querySelectorAll('[data-fs-model-screen]').forEach(function (node) {
      node.hidden = node.getAttribute('data-fs-model-screen') !== screen;
    });
  }

  function showBrandPanel(root, brand) {
    root.querySelectorAll('[data-fs-model-brand-panel]').forEach(function (node) {
      node.hidden = node.getAttribute('data-fs-model-brand-panel') !== brand;
    });
  }

  function setActive(root, kind, value) {
    var attr = 'data-fs-model-' + kind;
    root.querySelectorAll('[' + attr + ']').forEach(function (node) {
      var on = node.getAttribute(attr) === value;
      node.classList.toggle('is-active', on);
      if (on) node.setAttribute('aria-current', 'true');
      else node.removeAttribute('aria-current');
    });
  }

  function setFamilySectionActive(root, model) {
    root.querySelectorAll('[data-fs-model-family-section]').forEach(function (node) {
      node.classList.toggle(
        'is-active',
        node.getAttribute('data-fs-model-family-section') === model
      );
    });
  }

  function brandCard(root, brand) {
    return find(root, 'data-fs-model-brand', brand);
  }

  function familyCard(root, model) {
    return find(root, 'data-fs-model-family', model);
  }

  function updateArrows(wrap) {
    var rail = wrap.querySelector('.fs-mrail');
    if (!rail) return;

    var prev = wrap.querySelector('.fs-marrow--prev');
    var next = wrap.querySelector('.fs-marrow--next');
    var max = rail.scrollWidth - rail.clientWidth;
    var atStart = rail.scrollLeft <= 2;
    var atEnd = max <= 2 || rail.scrollLeft >= max - 2;

    if (prev) {
      prev.disabled = atStart;
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    }
    if (next) {
      next.disabled = atEnd;
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
  }

  function updateAllArrows(root) {
    root.querySelectorAll('.fs-mrail-wrap').forEach(function (wrap) {
      updateArrows(wrap);
    });
  }

  function railCards(rail) {
    return Array.prototype.slice.call(rail.querySelectorAll('.fs-mversion, .fs-mcard'));
  }

  /* Scroll positions where a card sits flush with the left edge of the rail
     (plus the far end, so the last cards can always be reached). */
  function snapPoints(rail) {
    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    if (max <= 1) return [0];

    var railLeft = rail.getBoundingClientRect().left;
    var points = [0];
    railCards(rail).forEach(function (card) {
      var left = card.getBoundingClientRect().left - railLeft + rail.scrollLeft;
      points.push(Math.max(0, Math.min(max, left - 4)));
    });
    points.push(max);
    points.sort(function (a, b) {
      return a - b;
    });
    return points.filter(function (point, index) {
      return index === 0 || point - points[index - 1] > 2;
    });
  }

  function nearestPoint(points, value) {
    var best = points[0] || 0;
    var distance = Infinity;
    points.forEach(function (point) {
      var next = Math.abs(point - value);
      if (next < distance) {
        distance = next;
        best = point;
      }
    });
    return best;
  }

  function ensureSpring(rail) {
    var physics = window.fsPhysics;
    if (!physics) return null;
    if (!rail._fsSpring) {
      rail._fsSpring = physics.spring({
        from: rail.scrollLeft,
        damping: 1,
        response: 0.32,
        onUpdate: function (value) {
          rail.scrollLeft = value;
        }
      });
    }
    return rail._fsSpring;
  }

  function finishSnap(rail) {
    rail.style.scrollSnapType = '';
    var wrap = rail.closest('.fs-mrail-wrap');
    if (wrap) updateArrows(wrap);
  }

  /* Apple-style settle: start from the live scroll position, carry the flick
     velocity, project where it is going, then spring to the nearest card. */
  function springRail(rail, target, velocity) {
    var physics = window.fsPhysics;
    if (!physics) {
      rail.scrollLeft = target;
      finishSnap(rail);
      return;
    }

    var spring = ensureSpring(rail);
    if (!spring) {
      rail.scrollLeft = target;
      finishSnap(rail);
      return;
    }

    if (physics.reduced && physics.reduced()) {
      spring.jump(target);
      rail.scrollLeft = target;
      finishSnap(rail);
      return;
    }

    rail.style.scrollSnapType = 'none';
    var speed = Math.abs(velocity || 0);
    spring.jump(rail.scrollLeft);
    spring.retarget(
      target,
      velocity || 0,
      speed > 300 ? 0.9 : 1,
      0.32,
      function () {
        rail.scrollLeft = target;
        finishSnap(rail);
      }
    );
  }

  function cancelSpring(rail) {
    if (rail._fsSpring) rail._fsSpring.stop();
  }

  function bindDrag(rail) {
    if (rail.dataset.fsDragBound === 'true') return;
    if (!window.fsPhysics) return;
    rail.dataset.fsDragBound = 'true';

    var tracker = window.fsPhysics.tracker();
    var drag = null;
    var suppressClick = false;

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      cancelSpring(rail);
      rail.style.scrollSnapType = 'none';
      drag = {
        id: event.pointerId,
        startX: event.clientX,
        startScroll: rail.scrollLeft,
        active: false
      };
      tracker.reset();
      tracker.add(rail.scrollLeft, performance.now());
    });

    rail.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.startX;

      if (!drag.active) {
        if (Math.abs(dx) < 5) return;
        drag.active = true;
        rail.classList.add('is-dragging');
        try {
          rail.setPointerCapture(event.pointerId);
        } catch (error) {
          /* older browsers: window listeners still get the release */
        }
      }

      event.preventDefault();
      rail.scrollLeft = drag.startScroll - dx;
      tracker.add(rail.scrollLeft, performance.now());
    });

    function endDrag(event) {
      if (!drag || event.pointerId !== drag.id) return;
      var active = drag.active;
      drag = null;
      rail.classList.remove('is-dragging');

      if (!active) {
        rail.style.scrollSnapType = '';
        return;
      }

      suppressClick = true;
      window.setTimeout(function () {
        suppressClick = false;
      }, 350);

      var velocity = tracker.velocity(performance.now());
      var projected = rail.scrollLeft + window.fsPhysics.project(velocity, 0.998);
      var target = nearestPoint(snapPoints(rail), projected);
      springRail(rail, target, velocity);
    }

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);

    rail.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function bindRails(root) {
    root.querySelectorAll('.fs-mrail').forEach(function (rail) {
      if (rail.dataset.fsRailBound === 'true') return;
      rail.dataset.fsRailBound = 'true';
      rail.addEventListener(
        'scroll',
        function () {
          var wrap = rail.closest('.fs-mrail-wrap');
          if (wrap) updateArrows(wrap);
        },
        { passive: true }
      );
      rail.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
      bindDrag(rail);
    });
  }

  function sync(root) {
    root = root || document;
    var wrap = root.querySelector('[data-fs-models]');
    if (!wrap) return;

    var params = new URLSearchParams(window.location.search);
    var brand = params.get(P.brand) || '';
    var model = params.get(P.model) || '';
    var version = params.get(P.version) || '';

    var versionCard = version ? find(wrap, 'data-fs-model-version', version) : null;
    if (!brand && versionCard) {
      brand = versionCard.getAttribute('data-brand') || '';
      if (!model) model = versionCard.getAttribute('data-model') || '';
    }

    var family = model ? familyCard(wrap, model) : null;
    if (!brand && family) brand = family.getAttribute('data-brand') || '';

    setActive(wrap, 'brand', brand);
    setActive(wrap, 'family', model);
    setActive(wrap, 'version', version);
    setFamilySectionActive(wrap, model);

    if (brand) {
      showBrandPanel(wrap, brand);
      setScreen(wrap, 'models');
      var card = brandCard(wrap, brand);
      setText(wrap, '[data-fs-model-brand-label]', card ? card.getAttribute('data-label') || brand : brand);
      setText(
        wrap,
        '[data-fs-model-brand-count]',
        card && card.getAttribute('data-count') ? card.getAttribute('data-count') + ' boots' : ''
      );
      bindRails(wrap);
      window.requestAnimationFrame(function () {
        updateAllArrows(wrap);
      });
    } else {
      setScreen(wrap, 'brands');
      setFamilySectionActive(wrap, '');
    }
  }

  function closeAndReveal() {
    if (window.FS && window.FS.closeDock) window.FS.closeDock();
    var delay = reduceMotion() ? 0 : 180;
    window.setTimeout(function () {
      var grid = document.getElementById('ProductGridContainer');
      if (grid) grid.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
    }, delay);
  }

  function apply(values) {
    var params = new URLSearchParams(window.location.search);
    Object.keys(P).forEach(function (key) {
      params.delete(P[key]);
    });
    params.delete('page');

    if (values.brand) params.set(P.brand, values.brand);
    if (values.model) params.set(P.model, values.model);
    if (values.version) params.set(P.version, values.version);

    var query = params.toString();

    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(query, null, true);
      if (window.FS && typeof window.FS.refreshSections === 'function') {
        window.FS.refreshSections(query).then(function () {
          if (window.FS.afterRefresh) window.FS.afterRefresh();
          closeAndReveal();
        });
      } else {
        closeAndReveal();
      }
    } else {
      window.location.search = query;
    }
  }

  document.addEventListener('click', function (event) {
    var brand = event.target.closest('[data-fs-model-brand]');
    if (brand) {
      event.preventDefault();
      var brandRoot = brand.closest('[data-fs-models]');
      if (!brandRoot) return;

      var brandValue = brand.getAttribute('data-fs-model-brand');
      setActive(brandRoot, 'brand', brandValue);
      setActive(brandRoot, 'family', '');
      setActive(brandRoot, 'version', '');
      setFamilySectionActive(brandRoot, '');
      showBrandPanel(brandRoot, brandValue);
      setScreen(brandRoot, 'models');
      setText(brandRoot, '[data-fs-model-brand-label]', brand.getAttribute('data-label') || brandValue);
      setText(
        brandRoot,
        '[data-fs-model-brand-count]',
        brand.getAttribute('data-count') ? brand.getAttribute('data-count') + ' boots' : ''
      );

      var panel = brandRoot.closest('.fs-fdock__panel');
      if (panel) panel.scrollTop = 0;

      bindRails(brandRoot);
      window.requestAnimationFrame(function () {
        updateAllArrows(brandRoot);
      });
      return;
    }

    var family = event.target.closest('[data-fs-model-family]');
    if (family) {
      event.preventDefault();
      var familyRoot = family.closest('[data-fs-models]');
      if (!familyRoot) return;

      var familyBrand = family.getAttribute('data-brand');
      var familyModel = family.getAttribute('data-fs-model-family');
      setActive(familyRoot, 'brand', familyBrand);
      setActive(familyRoot, 'family', familyModel);
      setActive(familyRoot, 'version', '');
      setFamilySectionActive(familyRoot, familyModel);
      apply({ brand: familyBrand, model: familyModel });
      return;
    }

    var version = event.target.closest('[data-fs-model-version]');
    if (version) {
      event.preventDefault();
      var versionRoot = version.closest('[data-fs-models]');
      if (!versionRoot) return;

      var versionBrand = version.getAttribute('data-brand');
      var versionModel = version.getAttribute('data-model');
      var versionValue = version.getAttribute('data-fs-model-version');
      setActive(versionRoot, 'brand', versionBrand);
      setActive(versionRoot, 'family', versionModel);
      setActive(versionRoot, 'version', versionValue);
      setFamilySectionActive(versionRoot, versionModel);
      apply({ brand: versionBrand, model: versionModel, version: versionValue });
      return;
    }

    var back = event.target.closest('[data-fs-model-back]');
    if (back) {
      event.preventDefault();
      var backRoot = back.closest('[data-fs-models]');
      if (!backRoot) return;

      var visible = backRoot.querySelector('[data-fs-model-brand-panel]:not([hidden])');
      var currentBrand = visible ? visible.getAttribute('data-fs-model-brand-panel') : '';
      setScreen(backRoot, 'brands');
      setActive(backRoot, 'brand', currentBrand);
      setActive(backRoot, 'family', '');
      setActive(backRoot, 'version', '');
      setFamilySectionActive(backRoot, '');

      var backPanel = backRoot.closest('.fs-fdock__panel');
      if (backPanel) backPanel.scrollTop = 0;
      return;
    }

    var arrow = event.target.closest('[data-fs-model-scroll]');
    if (arrow) {
      event.preventDefault();
      var arrowWrap = arrow.closest('.fs-mrail-wrap');
      var rail = arrowWrap ? arrowWrap.querySelector('.fs-mrail') : null;
      if (!rail) return;

      var direction = Number(arrow.getAttribute('data-fs-model-scroll')) || 1;
      var points = snapPoints(rail);
      var current = nearestPoint(points, rail.scrollLeft);
      var index = points.indexOf(current);
      if (index === -1) index = 0;
      var targetIndex = Math.max(0, Math.min(points.length - 1, index + direction));

      cancelSpring(rail);
      springRail(rail, points[targetIndex], 0);
      updateArrows(arrowWrap);
    }
  });

  document.addEventListener('fs:filters-applied', function () {
    sync(document);
    bindRails(document);
    updateAllArrows(document);
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      updateAllArrows(document);
    }, 120);
  });

  window.FS = window.FS || {};
  window.FS.initModelBrowser = function (root) {
    sync(root || document);
    bindRails(root || document);
    updateAllArrows(root || document);
  };

  sync(document);
  bindRails(document);
  updateAllArrows(document);
})();
